"use client";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ConsentSwitch from "../member-settings/consents/ConsentSwitch";
import { useMember } from "../../context/MemberContext";
import Button from "../Button";

interface Props {
  close: () => void
}

const SubscriptionModal: React.FC<Props> = ({ close }) => {
  const { t } = useTranslation("common");
  const { member, changeMemberConsents } = useMember();

  const nc = member.consents.find((c) => c.purposeKey === "newsletter");
  const eo = member.consents.find((c) => c.purposeKey === "exclusive-offers");

  const [newsletterConsent, setNewsletterConsent] = useState<{ purposeUid: string, value: boolean}>({ purposeUid: nc.purposeUid, value: !!nc.value });
  const [offersConsent, setOffersConsent] = useState<{ purposeUid: string, value: boolean}>({ purposeUid: eo.purposeUid, value: !!eo.value });

  const saveAndClose = async () => {
    changeMemberConsents([newsletterConsent, offersConsent]);
    close();
  };

  return (
    <div>
      <div className="my-6 text-2xl font-medium text-center">{t("subscription.modal.title")}</div>
      <div className="my-6 text-center text-sm">{t("subscription.modal.text")}</div>
      <div className="space-y-6">
        <ConsentSwitch consentKey="subscription.newsletter" value={newsletterConsent.value} onChange={(value) => setNewsletterConsent((v) => ({ ...v, value }))} disabled={false} />
        <ConsentSwitch consentKey="subscription.exclusiveOffers" value={offersConsent.value} onChange={(value) => setOffersConsent((v) => ({ ...v, value }))} disabled={false} />
      </div>
      <div className="w-full mt-12 flex justify-center">
        <Button onClick={() => saveAndClose()} data-pw="subscriptionModalClose">
          {t("save")}
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionModal;
